module.exports = polyfills_lib;


//////////////////
// WEBPACK FOOTER
// external "polyfills_lib"
// module id = 0
// module chunks = 2